import { Navbar, Container, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Logo from '../Images/logo.png';
import Login from './Login/Login';
import { useEffect, useState } from 'react';
import './Header.css';

function Header() {

    return (
        <Navbar collapseOnSelect expand="lg" bg="light">
            <Container>
                <Navbar.Brand to="/" style={{display:"flex", flexFlow:"row wrap", width:"80%", padding:"0.5rem"}}>
                    <img
                        alt="Logo"
                        src={Logo}
                        className="navbarImg"
                    />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav"/>
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="me-auto" style={{alignItems:"flex-end"}}>
                        <Nav.Link eventKey="1" as={Link} to="/" style={{ fontSize: '15px'}} className="navItem">
                            Home
                        </Nav.Link>

                        <Nav.Link eventKey="1" as={Link} to="/movies" style={{ fontSize: '15px' }} className="navItem">
                            Movies
                        </Nav.Link>

                        <Nav.Link eventKey="1" as={Link} to="/series" style={{ fontSize: '15px' }} className="navItem">
                            Series
                        </Nav.Link>

                        <Nav.Link eventKey="1" as={Link} to="/books" style={{ fontSize: '15px' }} className="navItem">
                            Books
                        </Nav.Link>

                        <Nav.Link eventKey="1" as={Link} to="/Saved" style={{ fontSize: '15px' }} className="navItem">
                            Saved
                        </Nav.Link>

                        <Nav.Link eventKey="1" as={Link} to="/Done" style={{ fontSize: '15px' }} className="navItem">
                            Done
                        </Nav.Link>
                        <Login />
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Header;